import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { AuthService } from '../../modules/core/services/auth.service';
import { LoaderService } from '../../modules/core/services/loader.service';
import { WindowRefService } from '../../modules/core/services/window.service';

@Component({
	selector: 'cfe-start',
	templateUrl: './start.component.html',
	styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {
	/**
	 * Returns the configured vanity url for `learn more`.
	 */
	public get learnMoreUrl() {
		return this.configService.config.vanityUrls?.learnMore;
	}

	public showCountryDeactivationNotice: boolean;

	constructor(
		private router: Router,
		private authService: AuthService,
		protected loader: LoaderService,
		protected configService: ConfigService,
		protected windowRef: WindowRefService
	) {}

	ngOnInit() {
		this.showCountryDeactivationNotice = this.configService.config.showCountryDeactivationNotice;
		this.authService.loggedIn(false).subscribe((loggedIn) => {
			if (loggedIn) {
				this.router.navigate(['/dashboard/']);
			} else {
				this.authService.logout(false).subscribe();
			}
		});
	}

	goToLogin() {
		this.loader.loader.startLoading();
		return (this.windowRef.nativeWindow.location.href = this.configService.config.loginUri + this.configService.config.clientId);
	}

	goToRegister() {
		this.router.navigate(['/register']);
	}
}
